// removed by extract-text-webpack-plugin
module.exports = {"Main":"src-containers-QRcode-__QRcodePage-module___Main","Blur":"src-containers-QRcode-__QRcodePage-module___Blur","Commands":"src-containers-QRcode-__QRcodePage-module___Commands","Preview":"src-containers-QRcode-__QRcodePage-module___Preview","Modal":"src-containers-QRcode-__QRcodePage-module___Modal"};


//////////////////
// WEBPACK FOOTER
// ./src/containers/QRcode/QRcodePage.module.css
// module id = 1246
// module chunks = 1